import React from 'react';
import { useQuery } from '@apollo/client';
import { freeze } from '@reduxjs/toolkit';
import {
  DashboardTemplateScope,
  IGetDashboardTemplatesByScopeQuery,
  IGetDashboardTemplatesByScopeQueryVariables,
} from '../../../../utils/apollo/graphqlSchema';
import { GET_DASHBOARD_TEMPLATES_BY_SCOPE } from '../../../../utils/apollo/dashboards';
import MyDashboards from './MyDashboards';
import useDashboardTemplatesReloadEffect from '../../utils/useDashboardTemplatesReloadEffect';

const DASHBOARD_TEMPLATE_QUERY_VARIABLES =
  freeze<IGetDashboardTemplatesByScopeQueryVariables>(
    {
      term: '',
      scopes: [DashboardTemplateScope.CreatedByMe],
    },
    true,
  );

const MyDashboardsController = () => {
  const { data, refetch } = useQuery<
    IGetDashboardTemplatesByScopeQuery,
    IGetDashboardTemplatesByScopeQueryVariables
  >(GET_DASHBOARD_TEMPLATES_BY_SCOPE, {
    variables: DASHBOARD_TEMPLATE_QUERY_VARIABLES,
  });

  useDashboardTemplatesReloadEffect(refetch);

  const myDashboards = data?.dashboardTemplatesByScope?.[0]?.entities;

  if (!myDashboards?.length) {
    return null;
  }

  return <MyDashboards templates={myDashboards} />;
};

export default MyDashboardsController;
